import styled from "styled-components";

export const SuccessModalWrapper = styled("div")(() => {
  return {
    overflow: "hidden",
    height: "100%",
    backgroundColor: "var(--color-background)",
    padding: "var(--cardPadding)",
    borderRadius: "1rem",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    "& .icon-box>svg": {
      display: "block",
      marginLeft: "auto",
      marginRight: "auto",
    },
    "& .title-box>h1": {
      textAlign: "center",
    },
    "& .message-box>p": {
      textAlign: "center",
    },
  };
});
